angular.module('impactx.basket').directive('appBasketSupplier', function () {
    return {
        scope: {
            basketHeader: "=",
            basketSupplierHeader: '=',
            selectedBasketItems: '=',
            selectedBasketSupplier: '=',
            showAddresses: "=?",
            showControl: "=?",
            showDate: "=?",
            showShare: "=?",
            showComments: "=?",
            form: '=',
            deleteItems: '&',
            numberOfSuppliers: '=',
            trns: '=',
            basketId: '=',
            markAsChanged: "&",
            showGross: "=",
            showNet: "=",
            showCatalogNet: "=",
            showItemControl: "=",
            showItemAddresses: "=",
            hideActions: "=",
            showItemComments: "=",
            isTemplate: "=",
            getBasket: '&',
            saveBasket: "&",
            rejectItem: "&",
            changePayerCompany: "&",
            prgSelected: "&",
            unbundleItem: "&",
            changeAat: "&",
            changeAatItem: "&",
            requireAat: "=",
            requireCtrl: "&",
            requireCtrlItem: "&",
            ignoreAccountingRequired: "=",
            ignoreMaterialGroupRequired: "=",
            readOnly: "=",
            showBasketItemOfferDialog: "=",
            deleteBasketItemGroup: "=",
            disableSendDistribListCheckbox: "=",
            openAddressDialog: "&",
            removeAddresses: "&",
            openAddressDialogItem: "&",
            removeAddressesItem: "&",
            openControlDialog: "&",
            removeControls: "&",
            openControlDialogItem: "&",
            removeControlsItem: "&",
            parentControlLabels: "=",
            hasControlLabels: "=",
            openDatesDialog: "&",
            removeDates: "&",
            openDatesDialogItem: "&",
            removeDatesItem: "&",
            dialogData: "=",
            changeOutlet: "&",
            hasSpoinfoFormular: "=",
            errorListDirty: "=",
            useBudgetProjectPreference: "=",
            useBudgetCostCenterPreference: "=",
            anySupplierHasAltDeliveryDates: "=",
            printTokens: "=",
            minimized: "="
        },
        restrict: 'E',
        controller: 'BasketSupplierCtrl',
        controllerAs: 'basketSupplierCtrl',
        templateUrl: 'modules/basket/templates/basketsupplier.html'
    };
});